import {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import propertyApi from "../../../services/propertyApi";
import FormLayout from "../../../componets/layout/FormLayout";
import equipmentApi from "../../../services/equipmentApi";
import Input from "../../../componets/inputs/Input";
import InputCurrency from "../../../componets/inputs/inputCurrency";
import ImageButton from "../../../componets/button/ImageButton";
import {RiImageAddFill} from "react-icons/ri";
import {IoClose} from "react-icons/io5";

export default function FormEquipment() {
    const defaltValues = {
        id: '',
        nome: '',
        tipo: '',
        valor: '',
        descricao: '',
        images: [],
        images_remove: [],
    }
    const [state, setState]: any = useState(defaltValues);
    const params = useParams();
    const [loading, setLoading] = useState(true);

    const [imagesScreen, setImagesScreen]: any = useState([]);
    const [imageRemove, setImageRemove] = useState([]);

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };

    const onSelectImages = async (data: any) => {
        const newState = {...state}
        let imagesData: any[] = []
        let imagesbase64: any[] = []
        imagesData = data.map((file: any) => {
            return(
                {
                    url_path: URL.createObjectURL(file),
                    original_name: file.name
                }
            )
        })
        if (imagesScreen.length){
            imagesData = imagesData.concat(imagesScreen);
        }
        data.map((img: any) => {
            convertFileToBase64(img, (str: any) => imagesbase64.push({
                url_path: str,
                original_name: img.name
            }))
        })

        if (newState.images.length){
            imagesbase64 = newState.images.concat(imagesbase64)
        }
        newState.images = imagesbase64
        setState(newState)
        setImagesScreen(imagesData)
    }

    const onRemoveImg = async (image: any) => {
        if (image.id){
            const newImageRemove = [...imageRemove];
            // @ts-ignore
            newImageRemove.push(image)
            setImageRemove(newImageRemove)
            const newState = {...state}
            if (newState.images_remove){
                newState.images_remove.push(image);
            }else{
                newState.images_remove = [image];
            }
            setState(newState);
        }
        const newImageScreen = [...imagesScreen];
        setImagesScreen(newImageScreen.filter((ips: any, indexIps: number) => image.original_name != ips.original_name))
    }

    function convertFileToBase64(file: any, callback: any, originalName?: boolean) {

        const reader = new FileReader();
        reader.readAsDataURL(file);
        if (originalName){
            reader.onloadend = () => callback({
                file: reader.result,
                original_name: file.name
            });
        }else{
            reader.onloadend = () => callback(reader.result);
        }

    }

    const getDatas = async () => {
        if (params.id){
            const {data, isError} = await equipmentApi.one(params.id);
            if (!isError){
                setState(data);
                setImagesScreen(data.images)
            }
        }
        setLoading(false)
    }

    useEffect(() => {
        if (params.id){
            getDatas();
        }else{
            setLoading(false)
        }
    }, []);

    return(
        <FormLayout
            title={'Cadastro de equipamento'}
            urlReturn={'/equipamentos/lista'}
            state={state}
            setState={setState}
            apiData={equipmentApi}
            defaltValues={defaltValues}
        >
            {
                loading ?
                    <span className="flex items-center justify-center h-7">
                        <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black"
                             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </span>
                    :
                    <div className={'flex md:flex-row w-full md:p-4 xs:p-1'}>
                        <div className={'w-full grid'}>
                            <div className="grid grid-cols-12 gap-5 mb-4">
                                <Input
                                    required
                                    label={'Nome'}
                                    value={state.nome}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'nome')}
                                />
                                <Input
                                    required
                                    label={'Tipo'}
                                    value={state.tipo}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'tipo')}
                                />
                                <InputCurrency
                                    required
                                    label={'Valor'}
                                    value={state.valor}
                                    className={'md:col-span-2 xs:col-span-12'}
                                    onChange={
                                        (value: any, name: any) => handleChange(value, 'valor')
                                    }
                                />
                                <Input
                                    label={'Descrição'}
                                    value={state.descricao}
                                    className={'md:col-span-6 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'descricao')}
                                />

                                <div className={'md:col-span-12 xs:col-span-12 flex gap-4 items-center content-center md:pt-5 content-center text-[25px] text-system-primary'}>
                                    <ImageButton
                                        onSelect={(e: any) => onSelectImages(e)}
                                        id={'images-vehicles'}
                                        icon={<RiImageAddFill/>}
                                        accept={'image/*'}
                                    />

                                </div>


                            </div>
                            {

                                imagesScreen.length ?
                                    <div className={'flex flex-wrap gap-3'}>
                                        {
                                            imagesScreen.map((image: any, index: number) => {
                                                return  <div className={'border-2 border-border p-1 rounded-md relative'}>
                                                    <button type={'button'} onClick={() => onRemoveImg(image)} className={'w-[20px] h-[20px] absolute text-system-primary top-1  rounded-full justify-center'}>
                                                        <IoClose/>
                                                    </button>
                                                    <img className={'w-[100px] h-[100px]'} src={image.url_path ? image.url_path : image.image_path}/>
                                                </div>
                                            })
                                        }
                                    </div>
                                    :''
                            }


                        </div>

                    </div>
            }
        </FormLayout>
    )
}